module.exports = __webpack_public_path__ + "static/media/icon_down.1e53d264.svg";